var getContainerPaddings = function getContainerPaddings(container) {
  var _window$getComputedSt = window.getComputedStyle(container),
      paddingTop = _window$getComputedSt.paddingTop,
      paddingLeft = _window$getComputedSt.paddingLeft,
      paddingRight = _window$getComputedSt.paddingRight,
      paddingBottom = _window$getComputedSt.paddingBottom;

  var verticalPaddings = parseFloat(paddingTop) + parseFloat(paddingBottom);
  var horizontalPaddings = parseFloat(paddingLeft) + parseFloat(paddingRight);
  return [verticalPaddings, horizontalPaddings];
};

export default getContainerPaddings;